export class BoundForError extends Error {}
